<template>
    <li class="nav-item">
        <a class="nav-link" :class="{ active: isActive }" data-toggle="tab" :href="href" role="tab">
            <i :class="icon" aria-hidden="true"></i>{{ title }}
        </a>
    </li>
</template>

<script setup lang="ts">
    defineProps<{
        title: string;
        icon: string;
        href: string;
        isActive?: boolean;
    }>();
</script>
